// extracted by mini-css-extract-plugin
export default {"container":"FloatingActionButtons_container__tqUrU"};